import { render } from "./Delete.vue?vue&type=template&id=1678cd10&scoped=true"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"

import "./Delete.vue?vue&type=style&index=0&id=1678cd10&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1678cd10"

export default script